import { useQuery } from "@tanstack/react-query";
import { useAuthState } from "@/modules/auth/presentation/model/useAuthState";
import { dashboardApi } from "./client";

export const dashboardKeys = {
  employeeProfile: ["dashboard", "employee-profile"] as const,
};

export function useEmployeeProfileQuery() {
  const { user } = useAuthState();
  const userId = user?.id;

  return useQuery({
    queryKey: [...dashboardKeys.employeeProfile, userId ?? ""] as const,
    queryFn: () => dashboardApi.getEmployeeProfile(),
    enabled: Boolean(userId),
    staleTime: 60_000,
  });
}
